/**
 * Opt-in invite/search flow tracing — no PII, no tokens.
 * Enable: REACT_APP_DEBUG_GROUP_INVITE=true or localStorage lockedin_debug_group_invite=1
 */
export function isGroupInviteDebugEnabled() {
  if (process.env.REACT_APP_DEBUG_GROUP_INVITE === 'true') return true;
  if (typeof localStorage === 'undefined') return false;
  try {
    return localStorage.getItem('lockedin_debug_group_invite') === '1';
  } catch (_) {
    return false;
  }
}

export function logGroupInviteDebug(stage, meta = {}) {
  if (!isGroupInviteDebugEnabled()) return;
  console.info('[group-invite]', { stage, ...meta });
}
